import HttpResponse from "../../../../../utils/http/http.response";

export enum OrderFinishedCargoOrdersUnbilledListResponseDataItemLackingRailyBillings {
  CARGO_RAILY = "CARGO_RAILY",
  TAXI_RAILY = "TAXI_RAILY",
  RAILY_TAXI = "RAILY_TAXI",
}

export type OrderFinishedCargoOrdersUnbilledListResponseDataClient = {
  name: string;
};

export type OrderFinishedCargoOrdersUnbilledListResponseDataItem = {
  id: string;
  startTime: Date;
  humanId: number;
  isCancelled: boolean;
  rideAddresses: (string | string[])[];
  passengers: string[];
  dispatch: string;
  client: OrderFinishedCargoOrdersUnbilledListResponseDataClient;
  taxiCorporations: string[];
  drivers: string[];
  externalId: string | null;
  lackingRailyBillings: OrderFinishedCargoOrdersUnbilledListResponseDataItemLackingRailyBillings[];
};

export type OrderFinishedCargoOrdersUnbilledListResponseData = {
  data: OrderFinishedCargoOrdersUnbilledListResponseDataItem[];
  totalCount: number;
};

type OrderFinishedCargoOrdersUnbilledListResponse =
  HttpResponse<OrderFinishedCargoOrdersUnbilledListResponseData>;

export default OrderFinishedCargoOrdersUnbilledListResponse;
